export default __webpack_public_path__ + "dribbble-logo.png";